import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import idx from 'idx';
import Carousel from 'react-slick';
import Meta from 'project/containers/meta';
import ProjectLink from 'common/containers/project_link';
import { trackMixpanel } from 'common/tracking';

const CAROUSEL_SETTINGS = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  dots: true,
  arrows: false
};

export default class Tour extends Component {
  constructor(props) {
    super(props);

    this.state = { atIntro: true };

    this.start = this.start.bind(this)
    this.next = this.next.bind(this);
    this.renderSlide = this.renderSlide.bind(this);
    this.trackChange = this.trackChange.bind(this);
    this.trackMixpanel = this.trackMixpanel.bind(this);
  }

  trackMixpanel(slideTitle, slideNumber) {
    const { location, project, categorySlug, subCategorySlug } = this.props;

    trackMixpanel("Viewed project tour", {
      projectJustPosted: !!idx(location, _ => _.state.isSuccess),
      projectId: project.id,
      categorySlug,
      subCategorySlug,
      slideTitle,
      slideNumber
    });
  }

  componentDidMount() {
    this.trackMixpanel("Intro", 0);
  }

  trackChange(idx) {
    this.trackMixpanel(this.props.slides[idx].title, idx + 1);
  }

  start() {
    this.setState({ atIntro: false });
    this.trackMixpanel(this.props.slides[0].title, 1);
  }

  next() {
    this.refs.tour_carousel.slickNext();
  }

  renderSlide(slide, i) {
    const { slides, project } = this.props;
    const isLast = i == slides.length - 1;

    return (
      <div key={i}>
        <div className={classnames("slide has-button", { last: isLast })}>
          <div className="row">
            <div className="small-16 medium-8 columns">
              { slide.header && <h5>{ slide.header }</h5> }
              <h2>{ slide.title }</h2>
              <div>{ slide.description }</div>

              { !isLast &&
              <button className="btn btn-tertiary hide-for-small-only" onClick={this.next}>
                Next
              </button> }

              { isLast &&
              <ProjectLink project={project} append="entries/" className="btn btn-tertiary">
                See entries
              </ProjectLink> }
            </div>
            <div className="small-16 medium-6 medium-offset-2 columns">
              <img src={slide.image} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { slides, intro } = this.props;

    return (
      <div className="row">
        <Meta title="Tour" />
        <div className="small-16 columns">
          <div className="project-tour">
            { this.state.atIntro?
            <div className="slide intro">
              <h2>{ intro.title }</h2>
              <p>{ intro.description }</p>

              <button className="btn btn-tertiary" onClick={this.start}>
                Start project tour
              </button>
            </div> :
            <Carousel {...CAROUSEL_SETTINGS} ref="tour_carousel" afterChange={this.trackChange}>
              { slides.map(this.renderSlide) }
            </Carousel> }
          </div>
        </div>
      </div>
    );
  }
}

Tour.propTypes = {
  intro: PropTypes.object.isRequired,
  slides: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  categorySlug: PropTypes.string.isRequired,
  subCategorySlug: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./project/components/tour.jsx